module.exports = __webpack_public_path__ + "img/3.117b690b.png";